export const keyCode = {
  ENTER: 13,
  TAB: 9,
}
export const fixSize = {
  WIDTH_HEADER: 300,
  WIDTH_CALENDAR: 580,
}
